module.exports = __webpack_public_path__ + "static/bandfoto-florian-8680887962a0eb123c8490d457601207.png";